import React from 'react';
import styled from 'styled-components';

import { StyledToggle, Input, Handle, DEFAULT_SIZE } from './toggleStyles';
import { ComponentProps } from './toggleTypes';

const Label = styled.div`
  cursor: pointer;
`;

const ChildrenWrap = styled.div<{
  $inline: boolean;
  $childrenAlignTop: boolean;
}>`
  display: ${({ $inline }) => ($inline ? 'inline-flex' : 'flex')};
  cursor: pointer;

  ${({ $childrenAlignTop }) =>
    $childrenAlignTop
      ? `
    align-items: flex-start;
    margin-top: 2px;
  `
      : `
    align-items: center;
  `};

  gap: 8px;

  ${StyledToggle} {
    flex-basis: 28px;
    flex-shrink: 0;

    transition: box-shadow 0.5s ease-out;
    box-shadow: 0 0 0 rgba(255, 255, 255, 0);
  }

  &:active ${StyledToggle} {
    transition: box-shadow 0.05s ease-in;
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
  }
`;

export default function ToggleSlider({
  checked,
  scale = DEFAULT_SIZE,
  inputProps,
  onChange,
  disabled,
  children,
  inline,
  childrenAlignTop,
}: ComponentProps) {
  const isChecked = !!checked;

  const slider = (
    <StyledToggle
      checked={isChecked}
      disabled={disabled}
      $scale={scale}
      style={{ opacity: disabled ? 0.5 : undefined }}
    >
      <Input
        checked={checked}
        $scale={scale}
        disabled={disabled}
        {...inputProps}
        onChange={
          children
            ? undefined // Wrapper is clickable instead
            : checked =>
                disabled ? undefined : onChange(checked.target.checked)
        }
        readOnly={!!children}
        type="checkbox"
      />
      <Handle checked={isChecked} $scale={scale} disabled={disabled} />
    </StyledToggle>
  );

  return children ? (
    <ChildrenWrap
      $inline={!!inline}
      $childrenAlignTop={!!childrenAlignTop}
      onClick={disabled ? undefined : () => onChange(!isChecked)}
    >
      {slider}
      <Label>{children}</Label>
    </ChildrenWrap>
  ) : (
    <>{slider}</>
  );
}
